import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-inline-loader, myt-app-inline-loader',
  templateUrl: './app-inline-loader.component.html',
  styleUrls: ['./app-inline-loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AppInlineLoaderComponent {
  @Input() active = false;
  @Input() label?: string;
  @Input() diameter = 16;
  @Input() ariaLabel = 'Loading';
  @Input() showLabel = true;
}
